module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY11.9a2b7705.jpg";